import { readonly, ref } from 'vue'

const open = ref(false)

/**
 * Module-scoped state for the sub-team picker modal. The picker is mounted
 * once at App.vue (so it can be opened from multiple entries — TeamPage,
 * TeamSwitcher, command palette later) and this composable is the only way
 * to read/toggle its visibility.
 */
export function useSubteamPicker() {
  return {
    open: readonly(open),
    openPicker: (): void => {
      open.value = true
    },
    closePicker: (): void => {
      open.value = false
    },
  }
}
